<template>
  <div class="addBankCard">
    <div class="title-box">
      <h5>添加银行卡</h5>
      <span>请绑定持卡人本人的银行卡</span>
    </div>
    <van-form @submit="onSubmit">
      <van-field
        v-model="name"
        name="name"
        label="持卡人"
        placeholder="持卡人"
        :rules="[{ required: true, message: '请填写持卡人姓名' }]"
      />
      <van-field
        v-model="bankNo"
        name="bankNo"
        label="卡号"
        type="digit"
        placeholder="持卡人本人银行卡号"
        :rules="[{ required: true, message: '请填写银行卡号' }]"
      />
      <!-- <van-field
        v-model="bankType"
        name="bankType"
        label="所属银行"
        placeholder="请输入所属银行"
        :rules="[{ required: true, message: '请填写所属银行' }]"
      /> -->
      <van-field
        readonly
        clickable
        name="picker"
        :value="bankType"
        label="所属银行"
        placeholder="请选择所属银行"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          value-key="name"
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>

      <van-field
        v-model="phone"
        name="phone"
        label="手机号"
        type="tel"
        placeholder="持卡人本人手机号"
        :rules="[{ required: true, message: '请填写手机号' }]"
      />
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit"
          >下一步</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      bankNo: "",
      phone: "",
      bankType: "",
      columns: [],
      showPicker: false,
      bank_type_id:""
    };
  },
  mounted() {
    this.getBankTypeList();
  },
  methods: {
    getBankTypeList() {
      this.$http.request(this.$http.pathMap.bankTypeList, "get").then((res) => {
        this.columns = res.data;
      });
    },
    onSubmit(values) {
      let params = {...values,bank_type_id:this.bank_type_id}
      this.$http
        .request(this.$http.pathMap.addBankCard, "post", params)
        .then((res) => {
          if (res.code === 200) {
            this.$toast("添加成功");
            this.name = "";
            this.bankNo = "";
            this.phone = "";
            this.bankType = "";
            let that = this;
            setTimeout(() => {
              that.$router.back();
            }, 1000);
          }
        });
    },
    onConfirm(value) {
      // console.log(value);
      this.bankType = value.name;
      this.bank_type_id = value.id
      this.showPicker = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.title-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 30px 0;
}
</style>
